import React,  { useState } from 'react';
import { find, sum } from 'lodash';
import ReactTable from 'react-table';
import Box from '../../common/Box';
import IncrementalLineChart from '../../widgets/charts/types/IncrementalLineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import countriesByAbbreviation from '../../common/CountriesByAbbreviation';
import CSV from '../../../helpers/CSVExport';
import { splitByThousands } from '../../../helpers/NumberFormatter';
import { formatTooltipLabelDoughnutWithPercentage, formatTooltipLabelWithCurrency } from '../../widgets/charts/Formatter';
import { territoriesBar, territoriesLine, territoriesPie } from '../../widgets/charts/ChartDefaults';
import Tooltip from '../../common/Tooltip';

var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');

const toolbarChartViewIcons = {
		table: tableSvg,
		line: lineSvg,
		pie: pieSvg,
		bar: barSvg
}

export default function ProductType(props) {
	const [mode, setMode] = useState('line');
	const { table = [] } = props;
	const { period, catalog, frontline, loading } = props.results || {};
	
	const exportToCsv = () => {
		let data = table.map(row => {
		  return {
			period: row.period,
			catalog: row.catalog,
			frontline: row.frontline
		  };
		});
		const filename = CSV.CSVHeader('product_type', null, (props.dateStart && props.dateEnd) ? {dateStart: props.dateStart, dateEnd: props.dateEnd} : null);
		return CSV.CSVExport(data, {filename}, 'product_type');
	}
	
	const getTimeseries = () => {
		return  {
			labels: period,
			datasets: [
				{label: 'Frontline', data: frontline, backgroundColor: "#3466CB", borderColor: "#3466CB",
        pointBackgroundColor: "#3466CB",
        pointBorderColor: "#3466CB"},
				{label: 'Catalog', data: catalog, backgroundColor: "#FF9900", borderColor: "#FF9900",
        pointBackgroundColor: "#FF9900",
        pointBorderColor: "#FF9900"}
			]
		};
	}
	
	const getPie = () => {
		let dataset = [
			sum(frontline),
			sum(catalog),
		], 
		labels = ['Frontline', 'Catalog'];
		return {
			labels: labels,
			datasets: [{
				data: dataset, label: 'revenue', backgroundColor: ["#3466CB", "#FF9900"]
			}]
		};		
	}
	
	const getTable = () => {
		const commonColumnProps = {
			className: 'table-text-right', 
			headerClassName: 'table-text-right',
		};
		let columns = [
			{
				id: 'period',
				accessor: 'period',
				Header: 'Period',
				...commonColumnProps
			},
			{
				id: 'frontline',
				accessor: 'frontline',
				Header: 'Frontline',
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps
			},
			{
				id: 'catalog',
				accessor: 'catalog',
				Header: 'Catalog',
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps
			},

		];
		return <ReactTable 
			className=""
			data={table} 
			columns={columns}
			defaultPageSize={10}
			showPagination={true}        	
		/>
	}
	
	const renderToolbar = () => {
		let toolbar = [];
		let views = {
			'table': 'table',
			'line': 'chart-line',
			'bar': 'chart-bar',
			'pie': 'chart-pie'
		}
		for (let view in views) {
			toolbar.push(<a key={view} className={`chart-icon ${mode == view? 'active' : ''}`} onClick={()=>setMode(view)} dangerouslySetInnerHTML={{__html: toolbarChartViewIcons[view]}}></a>);
		}
		toolbar.push(<a key='download' className="chart-icon" onClick={()=>exportToCsv()} dangerouslySetInnerHTML={{__html: downloadSvg}}></a>);
		return toolbar;
	}


	const title = <React.Fragment>
		Catalog vs. Frontline
		<Tooltip 
			position="top" 
			message={`Catalog is defined as any release older than 18 months`} 
			tooltipClass="toolbar-title-tooltip"
			customIcon={true}>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
				<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
				<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
			</svg>
		</Tooltip>
	</React.Fragment>
	
	return <Box title={title} spinnerEnabled={loading} toolbar={renderToolbar()}>
		{period && <div className="chart-block">
			{mode == 'line' && <IncrementalLineChart data={getTimeseries()} options={territoriesLine()} chartID="territories_report_product_types_chart" />}
			{mode == 'bar' && <StackedBarChart data={getTimeseries()} isCustomWidth={true} options={territoriesBar()} chartID="territories_report_product_types_chart" />}
			{mode == 'pie' && <DoughnutChart data={getPie()} options={territoriesPie} chartID="territories_report_product_types_chart" />}
			{mode == 'table' && getTable()}
		</div>}
	</Box>
}
